import { ServiceResponse } from '@sdbn/common';

export enum ReferenceType {
    TIME_SLOT_BOOKING = 'TIME_SLOT_BOOKING'
}

export enum TransportScope {
  SWAP_TRAILER = 'SWAP_TRAILER', TRAILER = 'TRAILER', TRAIN = 'TRAIN', SEMI_TRAILER_TRUCK = 'SEMI_TRAILER_TRUCK'
}


export class Transport {
  id: number;
  name: string;
  carrier: string;
  reference: number;
  referenceType: ReferenceType;
  supplementaryEquipments: SupplementaryEquipment[] = [];
  saveMultipleConfirmed = false;
  noSupplementaryEquipmentHandout: boolean;
  supplementaryEquipmentHandoutHappened: boolean;
  identifier: string;
  transportScope: TransportScope;
}

export class SupplementaryEquipment {
  equipmentTypeId: string;
  name: string;
  selected: boolean;
  selectedIdentifier: string;
  availableIdentifiers: Array<string>;
}

export class HandoutSeServiceResponse extends ServiceResponse {

  confirmMultipleSmartphones: boolean;
  confirmMultiplePagers: boolean;

}